module.exports = __webpack_public_path__ + "img/y- (18).10882d02.png";